import React, { useState } from 'react';
import sILogo from '../../assets/img/somosIntercorp_logo.png';

export default function ({ token, first_name }) {
  
  const goToPage = (url, ext) => {
    const fullUrl = token !== '' ? `${url}?tk=${token}` : url;
    if (ext) {
      window.open(fullUrl, '_blank');
    } else {
      window.location.replace(fullUrl);
    }
  };

  const [mostrarSocial, setMostrarSocial] = useState(false);

  const mostrarMenuSocial = () => {
    setMostrarSocial(!mostrarSocial);
  };

  const cerrarSesion = () => {
    localStorage.removeItem('jwt');
    sessionStorage.removeItem('jwt');
    window.location.href = 'https://somosintercorp.net/Account/Login';
  };

  return (
    <section className='headerSI'>
      <header>
        <div className='row container-main' style={{ 'margin': 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <a href='https://somosintercorp.net/' className='logo-content'>
              <img
                src={sILogo}
                className='logo_header p-0 logo-web'
                alt='Intercorp logo'
              />
            </a>
          </div>
          <div className='navigation d-flex'>
            <ul className='menu header_options value-sans-pro-bold'>
              <li className='nav-item entrenate'>
                <a
                  className='nav-link font-weight-700'
                  href='javascript:void(0);'
                  onClick={(e) => {
                    e.preventDefault();
                    goToPage('https://entrenate.ucic.pe/', true)
                  }}
                >
                  <span className='entrenate value-sans-pro-medium font-weight-500'>
                    Entrénate
                  </span>
                </a>
              </li>
              <li className='nav-item enterate'>
                <a
                  className='nav-link font-weight-700'
                  href='javascript:void(0);'
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = 'https://enterate.somosintercorp.net/';
                  }}
                >
                  <span className='enterate value-sans-pro-medium font-weight-500'>
                    Entérate
                  </span>
                </a>
              </li>
              <li className='nav-item beneficiate'>
                <a className='nav-link font-weight-700'
                  href='javascript:void(0);'
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = 'https://beneficiate.somosintercorp.net/';
                  }}
                >
                  <span className='beneficiate value-sans-pro-medium font-weight-500'>
                    Benefíciate
                  </span>
                </a>
              </li>
              <li className='nav-item crece'>
                <a
                  className='nav-link font-weight-700'
                  href='javascript:void(0);'
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = 'https://crece.somosintercorp.net/';
                  }}
                >
                  <span className='crece value-sans-pro-medium font-weight-500'>
                    Crece
                  </span>
                </a>
              </li>
              <li className='nav-item contribuye'>
                <a
                  className='nav-link font-weight-700'
                  href='javascript:void(0);'
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = 'https://contribuye.ucic.pe/';
                  }}
                >
                  <span className='contribuye value-sans-pro-medium font-weight-500'>
                    Contribuye
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <div className='social' onClick={mostrarMenuSocial}>
            <div className='user'>
              <span className='nav-link user-icon initials'>
                <img src='https://beneficiate.somosintercorp.net/assets/images/icon-user.png' alt='' />
                <span className='value-sans-pro-medium font-weight-500'>
                  Hola, {first_name.toUpperCase()}
                </span>
              </span>
              {mostrarSocial && (
                <div className='user-dropdown'>
                  <ul className='options'>
                    <li>
                      <a href='https://colaboradores-intercorp.com'>
                        <span className='value-sans-pro-medium font-weight-500'>
                          Editar mis datos
                        </span>
                      </a>
                    </li>
                    <hr />
                    <li>
                      <a
                        href='https://docs.google.com/document/d/1tb85TniaB-6QhkuZWyLMd-SBXUd7Bonfji7147Mne7A/edit?usp=sharing'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <span className='value-sans-pro-medium font-weight-500'>
                          Preguntas frecuentes
                        </span>
                      </a>
                    </li>
                    <hr />
                    <li>
                      <a
                        href='https://docs.google.com/document/d/1tb85TniaB-6QhkuZWyLMd-SBXUd7Bonfji7147Mne7A/edit?usp=sharing'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <span className='value-sans-pro-medium font-weight-500'>
                          Contacto y consultas
                        </span>
                      </a>
                    </li>
                    <hr />
                    <li className='exit'>
                      <a href='javascript:void(0);' onClick={cerrarSesion}>
                        <i className='fas fa-sign-out-alt mr-2' aria-hidden='true' />
                        <span className='value-sans-pro-medium font-weight-500'>
                          Cerrar sesión
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </section >
  );
}
